import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  fill: "none",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#86A315",
      d: "m6.778 9.625-1.972 1.887a4.04 4.04 0 0 0-1.263 2.917c0 1.094.454 2.143 1.263 2.917a4.42 4.42 0 0 0 3.05 1.208c1.144 0 2.24-.435 3.05-1.208l2.627-2.515a4.1 4.1 0 0 0 1.06-1.667 3.95 3.95 0 0 0 .141-1.947 4.04 4.04 0 0 0-.81-1.79 4.3 4.3 0 0 0-1.581-1.235l-.842.806q-.129.123-.222.274c.481.132.918.382 1.267.725s.598.767.723 1.23c.125.464.121.95-.01 1.412a2.7 2.7 0 0 1-.742 1.221L9.89 16.374a2.94 2.94 0 0 1-2.034.806c-.763 0-1.495-.29-2.035-.806a2.7 2.7 0 0 1-.842-1.946c0-.73.303-1.43.842-1.946l1.14-1.089a5.3 5.3 0 0 1-.184-1.768"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#86A315",
      d: "M9.468 7.054a4.1 4.1 0 0 0-1.06 1.667 3.95 3.95 0 0 0-.14 1.947c.116.65.394 1.264.81 1.79.416.527.958.95 1.58 1.234l1.114-1.067a2.9 2.9 0 0 1-1.288-.712 2.7 2.7 0 0 1-.744-1.232 2.63 2.63 0 0 1 0-1.424c.13-.466.387-.891.744-1.232l2.627-2.514a2.94 2.94 0 0 1 2.034-.806c.763 0 1.494.29 2.034.806s.842 1.216.842 1.946-.303 1.43-.842 1.945l-1.14 1.09c.16.577.223 1.175.184 1.769l1.972-1.887a4.04 4.04 0 0 0 1.263-2.917 4.04 4.04 0 0 0-1.263-2.917 4.41 4.41 0 0 0-3.05-1.208c-1.143 0-2.24.435-3.05 1.208z"
    }, null, -1)
  ]))]))
}
export default { render: render }